module.exports = __webpack_public_path__ + "static/img/platform-demo.4c88039.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/software/platform/platform-demo.png
// module id = GJI8
// module chunks = 0